export const ServiceIntro2: React.FC = () => {
  return (
    <img
      src={`${process.env.IMG_SERVER}/service/service2.png`}
      className="mr-4 max-w-[136px] max-h-[136px]"
      alt=""
    />
  )
}
